import type { ChartExcelRow } from './chartExcel';

export interface LineChartSeries {
	id: string | number;
	label?: string;
	data: Array<{ x: string | number; y: number }>;
}

/**
 * BaseEntityLineChart (and every one of its 7 consumers) — one row per `x` value (ascending),
 * one column per series (`label ?? id`). Missing points -> `null`, not `0` (absent data must
 * not read as "zero"). Vertical/line layout: no reversal.
 */
export function seriesToRows(series: LineChartSeries[]): ChartExcelRow[] {
	const xValues: Array<string | number> = [];
	const seenX = new Set<string | number>();
	for (const s of series) {
		for (const point of s.data) {
			if (!seenX.has(point.x)) {
				seenX.add(point.x);
				xValues.push(point.x);
			}
		}
	}
	xValues.sort((a, b) => Number(a) - Number(b));

	return xValues.map((x) => {
		const row: ChartExcelRow = { 'Năm': x };
		for (const s of series) {
			const column = s.label ?? s.id;
			const point = s.data.find((p) => p.x === x);
			row[column] = point ? point.y : null;
		}
		return row;
	});
}

/**
 * AdmissionMethodsBarChart — reuses the already-filtered `filteredChartData.data` rows
 * (`indexBy` renamed to `Năm`), one column per key in `filteredChartData.keys`. `layout` is
 * `"vertical"` (reads top-to-bottom naturally): no reversal.
 */
export function stackedBarToRows(
	data: Array<Record<string, string | number>>,
	keys: string[],
	indexBy: string,
): ChartExcelRow[] {
	return data.map((item) => {
		const row: ChartExcelRow = { 'Năm': item[indexBy] };
		for (const key of keys) {
			row[key] = key in item ? item[key] : null;
		}
		return row;
	});
}
